/// <amd-module name="Tfs/Platform/DeviceType" />
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

/**
 * Information about the type of device the user is on
 */
export interface IDeviceType {
    mobile: boolean;
    phone: boolean;
    tablet: boolean;
}

/**
 * Service for detection of device types
 */
export interface IDeviceTypeService extends IVssService {
    /**
     * Gets information about the type of device the user is on
     */
    getDeviceType(): IDeviceType;
}

interface IDeviceTypeData {
    isMobileDevice?: boolean;
    isTabletDevice?: boolean;
}

class DeviceTypeService extends VssService implements IDeviceTypeService {
    public getDeviceType(): IDeviceType {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        const mobileData = contributionService.getData<IDeviceTypeData>("ms.vss-web.device-type-data") || {};
        return {
            mobile: !!mobileData.isMobileDevice,
            phone: !!mobileData.isMobileDevice && !mobileData.isTabletDevice,
            tablet: !!mobileData.isTabletDevice
        };
    }
}

export function getDeviceType(pageContext: IVssPageContext): IDeviceType {
    return pageContext.getService<IDeviceTypeService>("IDeviceTypeService").getDeviceType();
}

Services.add("IDeviceTypeService", { serviceFactory: DeviceTypeService });
